import Autocomplete, {
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
} from "@mui/material/Autocomplete";
import { SxProps, Theme } from "@mui/material/styles";
import { MaterialInput } from "./material-input";
import { InputProps } from "@mui/material/Input/Input";
import { IconButtonProps, PaperProps, PopperProps } from "@mui/material";

interface MaterialInputAutoCompleteProps {
  colorTheme: "black" | "white" | "blue" | "green";
  options: readonly any[];
  defaultValue?: any;
  multiple?: any;
  value?: any;
  inputValue?: string;
  onChange?:
    | ((
        event: React.SyntheticEvent<Element, Event>,
        value: any,
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<any> | undefined
      ) => void)
    | undefined;
  getOptionLabel?: ((option: any) => string) | undefined;
  filterSelectedOptions?: boolean;
  label?: string;
  sx?: SxProps<Theme> | undefined;
  textFieldSx?: SxProps<Theme>;
  InputProps?: Partial<InputProps>;
  size?: "small" | "medium" | undefined;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  isOptionEqualToValue: (option: any, value: any) => boolean;
  slotProps?:
    | {
        clearIndicator?: Partial<IconButtonProps>;
        paper?: PaperProps;
        popper?: Partial<PopperProps>;
        popupIndicator?: Partial<IconButtonProps>;
      }
    | undefined;
}

export function MaterialInputAutoComplete(
  props: MaterialInputAutoCompleteProps
) {
  return (
    <Autocomplete
      disablePortal
      slotProps={props.slotProps}
      disabled={props.disabled}
      multiple={props.multiple}
      options={props.options}
      sx={props.sx}
      size={props.size}
      value={props.value}
      fullWidth={props.fullWidth}
      defaultValue={props.defaultValue}
      getOptionLabel={props.getOptionLabel}
      onChange={props.onChange}
      filterSelectedOptions={props.filterSelectedOptions}
      isOptionEqualToValue={props.isOptionEqualToValue}
      renderInput={(params) => (
        <MaterialInput
          {...params}
          colorTheme={props.colorTheme}
          onChange={() => {}}
          required={props.required}
          placeholder={props.placeholder}
          name=""
          sx={props.textFieldSx}
          value={props.inputValue}
          label={props.label}
        />
      )}
    />
  );
}
